// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckEvid_container__1sVsw","header":"CheckEvid_header__3iCLr","body":"CheckEvid_body__1oti6","box":"CheckEvid_box__3oE7t"};